import * as React from "react";
import { OptionsObject, useSnackbar } from "notistack";
import { EVENT_TOASTR_NOTIFY } from "../../Events";
import { useHubXSubscribe } from "../../HubX";

export type ToastrListener = {
  message: string;
} & OptionsObject;

function ToastrListener() {
  const toastr = useSnackbar();

  const doNotify = (toastrObj: ToastrListener) => {
    const { message, ...options } = toastrObj;

    toastr.enqueueSnackbar(message, options);
  };

  useHubXSubscribe(EVENT_TOASTR_NOTIFY, doNotify, true);

  return null;
}

export default ToastrListener;
